module.exports = __webpack_public_path__ + "media/books/Testimonial-c6f323e7.jpg";